import React from "react";

// value: {type, setType, isShow, isEdit, isCreate, isCreateChild, isCreateOrEdit,
//         _dataFromServer, _dataToServer, _handleSetData, codeApi, errors,
//         doLoad, doUpdate, doCreate, doDelete, reSetData, setTitle, checkPermission}
export const ContextContent = React.createContext(null);
